import { Grid } from "@albelli/arc-3-react/lib/Grid";
import { Icon } from "@albelli/arc-3-react/lib/Icon";
import { LanguageSelector } from "@albelli/arc-3-react/lib/LanguageSelector/LanguageSelector";
import "@albelli/arc-3/lib/footer.css";
import { requestMenu } from "application/menu/menuActions";
import classnames from "classnames";
import { isLoading, isNotRequested } from "helpers/requestStateHelper";
import { vendor } from "helpers/vendorHelper";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const FooterItem = ({ icon, img, text, href, className }) => {
  let innerItem = text;
  let listItem = true; //listItem = auto wrap (1 item per line)

  //arc3-icon specified - i.e. social icons
  if (icon) {
    listItem = false;
    innerItem = (
      <Icon className={`icon--background-color-brand-cyan icon-${icon}`} size="small" name={icon}>
        {icon}
      </Icon>
    );
  }
  //if has img src - awards or payment options
  else if (img) {
    listItem = false;
    innerItem = <img className={className} src={img} alt={text} style={{ maxWidth: "200px" }} />;
  }
  //if it has a class it is a wrapped div icon - i.e. the app icons, else its just text
  else if (!!className) {
    innerItem = <div className={className} />;
  }

  //if href wrap in an anchor
  if (href) {
    innerItem = (
      <a href={href} alt={text}>
        {innerItem}
      </a>
    );
  }
  return listItem ? <li>{innerItem}</li> : innerItem;
};

const FooterSection = ({ index, text, items, className }) => {
  return (
    <Grid cell column={3} columnTablet={6} columnPhone={index < 4 ? 2 : 4}>
      <h5 className="arc3-footer__title">{text}</h5>
      {!!items && (
        <ul className={classnames("arc3-typo-ul-no-style arc3-footer__anchor", className)}>
          {items.map((i, j) => (
            <FooterItem key={j} {...i} />
          ))}
        </ul>
      )}
    </Grid>
  );
};

const FooterBar = ({ links, copyright }) => {
  const vendorFlags = [
    { vendorId: "albelli.nl", flag: "flag-nl", text: "NL" },
    { vendorId: "albelli.de", flag: "flag-de", text: "DE" },
    { vendorId: "bonusprint.co.uk", flag: "flag-uk", text: "UK" },
    { vendorId: "monalbumphoto.fr", flag: "flag-fr", text: "FR" },
    { vendorId: "albelli.be", flag: "flag-be", text: "BE" },
    { vendorId: "fotoknudsen.no", flag: "flag-no", text: "NO" },
    { vendorId: "onskefoto.se", flag: "flag-se", text: "SE" }
  ];

  const vendorFlagLinks = vendorFlags.map(f => {
    return { href: window.location.href.replace(vendor, f.vendorId), ...f };
  });

  return (
    <div id="arc3-footer__end-row">
      <div className="arc3-container">
        <Grid container>
          <Grid cell column={4} columnTablet={3} columnPhone={2}>
            <p>{copyright}</p>
          </Grid>
          <Grid cell column={8} columnTablet={9} columnPhone={12}>
            <ul className="arc3-typo-ul-no-style arc3-footer__anchor arc3-footer__horizontal-menu">
              {!!links &&
                links.map((i, j) => (
                  <li key={j}>
                    <a href={i.href}>{i.text}</a>
                  </li>
                ))}
              <LanguageSelector vendorFlagLinks={vendorFlagLinks} currentVendor={vendor} />
            </ul>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export const Footer = () => {
  const menu = useSelector(state => state.menu);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isNotRequested(menu)) {
      dispatch(requestMenu());
    }
  }, []);

  const { items } = menu;
  if (isLoading(menu) || !items) return null;

  return (
    <div className="arc3-footer">
      <div className="arc3-container">
        <div className="arc3-grid">
          {!!items.footer &&
            items.footer.map((footerItem, index) => <FooterSection key={index} index={index} {...footerItem} />)}
        </div>
      </div>
      <FooterBar links={items.links} copyright={items.copyright} />
    </div>
  );
};
